import { NumberRange } from '@models/DomainModels/Master/number-range';
import { NumberRangeScope } from '@models/enums/NumberRangeScope';
import { ColDef, ValueGetterParams } from 'ag-grid-enterprise';

interface GridColumnParams {
  t: (key: string, options?: { ns?: string }) => string;
}

export const gridColumnDefinitions = ({ t }: GridColumnParams): ColDef<NumberRange>[] => {
  const columns: ColDef<NumberRange>[] = [
    {
      field: 'scope',
      flex: 1,
      sortable: true,
      filter: 'agSetColumnFilter',
      headerName: t('headers.scope'),
      valueFormatter: params => {
        if (!params.value) return null;
        // Extract enum key from value for translation
        const typeKey = Object.entries(NumberRangeScope).find(([, val]) => val === params.value)?.[0];
        return typeKey ? t(`enums:numberRangeScope.${typeKey}`) : params.value;
      },
      filterValueGetter: (params: ValueGetterParams<NumberRange>) => {
        if (!params.data?.scope) return null;
        // Extract enum key from value for translation
        const typeKey = Object.entries(NumberRangeScope).find(([, val]) => val === params.data?.scope)?.[0];
        return typeKey ? t(`enums:numberRangeScope.${typeKey}`) : params.data?.scope;
      }
    },
    {
      field: 'name',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.name')
    },
    {
      field: 'format',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.format')
    },
    {
      field: 'lastNumberUsed',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.lastNumberUsed'),
      valueFormatter: params => {
        if (params.value === null || params.value === undefined) return '';
        return String(params.value);
      },
      filterValueGetter: (params: ValueGetterParams<NumberRange>) => {
        if (params.data?.lastNumberUsed === null || params.data?.lastNumberUsed === undefined) return null;
        return String(params.data.lastNumberUsed);
      }
    }
  ];

  return columns;
};
